import React, { useState} from "react";
import { PopupBookingComponent } from "../../../../components";
import moment from "moment";
function EndowList({ endows, fromDate, toDate, hotels, check }) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);
  return (
    <div className="endowList">
      {endows
        .filter(
          (endow) =>
            (hotels == null || hotels == "" || endow.hotel_code == hotels) &&
            (((fromDate == null || fromDate == "") &&
              (toDate == null || toDate == "")) ||
              (fromDate != null &&
                (toDate == null || toDate == "") &&
                moment(endow.start_date, "DD-MM-YYYY").unix() >=
                  moment(fromDate, "DD-MM-YYYY").unix()) ||
              (toDate != null &&
                (fromDate == null || fromDate == "") &&
                moment(endow.end_date, "DD-MM-YYYY").unix() >=
                  moment(toDate, "DD-MM-YYYY").unix()) ||
              (fromDate != null &&
                toDate != null &&
                moment(endow.start_date, "DD-MM-YYYY").unix() >=
                  moment(fromDate, "DD-MM-YYYY").unix() &&
                moment(endow.end_date, "DD-MM-YYYY").unix() >=
                  moment(toDate, "DD-MM-YYYY").unix())) &&
            (check == null || check == "" || check.includes(endow.endow_type))
            
        )
        .map((item, index) => {
          return (
            <div className="row endowBox" key={index}>
              <div className="col-lg-6 col-12 col-md-6">
                <div className="imgEndow">
                  <img className="img-fluid" src={item.image} alt="" />
                </div>
              </div>
              <div className="col-lg-6 col-12 col-md-6">
                <div className="endowContent">
                  <h5 className="title">{item.name}</h5>
                  <div className="textContent">
                    <p>{item.description}</p>
                  </div>
                  <div className="bookingTime">
                    <label>Thời gian đặt</label>
                    <div className="flex_between">
                      <div className="time">
                        <img src="/images/ic_date_new.png" alt="" />
                        <span>
                          <span>{item.start_date}</span>
                          <span> - </span>
                          <span>{item.end_date}</span>
                        </span>
                      </div>
                      <button className="bookingBtn" onClick={showModal}>Đặt phòng ngay</button>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      <PopupBookingComponent isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} />
    </div>
  );
}
export default EndowList;
